import { normalizeString } from '@leedpulse-monorepo/utils';

export function formatDefinedDemoEmail(
    mailBase: string,
    index: number,
    mailDomain: string,
    countryCode: string,
    offset = 0,
): string {
    const local = `${normalizeString(mailBase)}.${index + offset}`
        .replace(/\.+/g, '.')
        .replace(/^\./, '')
        .replace(/\.$/, '');
    const host = `${normalizeString(mailDomain).replace(/\s+/g, '')}.${normalizeString(countryCode).replace(/\s+/g, '')}`
        .replace(/\s+/g, '')
        .toLowerCase();
    return `${local}@${host}`;
}

export function formatDefinedDemoEmailHost(mailDomain: string, countryCode: string): string {
    return `${normalizeString(mailDomain).replace(/\s+/g, '')}.${normalizeString(countryCode).replace(/\s+/g, '')}`
        .replace(/\s+/g, '')
        .toLowerCase();
}
